import styled from "styled-components";

export const InputSearch2Styled = styled.div`
  .theme_standard_search {
    .label_show {
      font-size: ${({ theme }) => theme.FONT.SIZE.S16};
      font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
      color: ${({ theme }) => theme.COLORS.GRAY_23};
      margin-bottom: 4px;
    }
    .line_search {
      display: flex;
      justify-content: space-between;
      .search_layout {
        width: 100%;
        position: relative;
        .icon {
          position: absolute;
          top: 14px;
          right: 16px;
          cursor: pointer;
        }
        .input_serach {
          font-size: ${({ theme }) => theme.FONT.SIZE.S16};
          font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
          color: ${({ fontColor, theme }) =>
            fontColor ? fontColor : theme.COLORS.GRAY_23};
          width: 100%;
          border: 1px solid ${({ theme }) => theme.COLORS.GRAY_10};
          padding: 8.4px 10px;
          padding-right: 48px;
          border-radius: 8px;
          box-sizing: border-box;
          &::-webkit-input-placeholder {
            /* Chrome/Opera/Safari */
            color: ${({ theme }) => theme.COLORS.GRAY_30};
          }
          &::-moz-placeholder {
            /* Firefox 19+ */
            color: ${({ theme }) => theme.COLORS.GRAY_30};
          }
          &:-ms-input-placeholder {
            /* IE 10+ */
            color: ${({ theme }) => theme.COLORS.GRAY_30};
          }
          &:-moz-placeholder {
            /* Firefox 18- */
            color: ${({ theme }) => theme.COLORS.GRAY_30};
          }
        }
      }
      .btn_serach {
        width: 25%;
      }
    }
    .show_label {
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      margin-top: 1px;
      display: flex;
      justify-content: flex-end;
      .btn_label {
        width: 25%;
        text-align: center;
      }
    }
  }

  .theme_standard_search_2 {
    .label_show {
      font-size: ${({ theme }) => theme.FONT.SIZE.S16};
      font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
      color: ${({ theme }) => theme.COLORS.GRAY_23};
      margin-bottom: 4px;
    }
    .line_search {
      display: flex;
      justify-content: space-between;
      .search_layout {
        width: 100%;
        position: relative;
        .icon {
          position: absolute;
          top: 10px;
          right: 16px;
          cursor: pointer;
        }
        .input_serach {
          font-size: ${({ theme }) => theme.FONT.SIZE.S16};
          font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
          color: ${({ fontColor, theme }) =>
            fontColor ? fontColor : theme.COLORS.GRAY_23};
          width: 100%;
          border: 1px solid ${({ theme }) => theme.COLORS.GRAY_10};
          padding: 8.4px 10px;
          padding-right: 48px;
          border-radius: 8px;
          box-sizing: border-box;
          &::-webkit-input-placeholder {
            /* Chrome/Opera/Safari */
            color: ${({ theme }) => theme.COLORS.GRAY_30};
          }
          &::-moz-placeholder {
            /* Firefox 19+ */
            color: ${({ theme }) => theme.COLORS.GRAY_30};
          }
          &:-ms-input-placeholder {
            /* IE 10+ */
            color: ${({ theme }) => theme.COLORS.GRAY_30};
          }
          &:-moz-placeholder {
            /* Firefox 18- */
            color: ${({ theme }) => theme.COLORS.GRAY_30};
          }
        }
      }
      .btn_serach {
        width: 25%;
      }
    }
    .show_label {
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      margin-top: 1px;
      display: flex;
      justify-content: flex-end;
      .btn_label {
        width: 25%;
        text-align: center;
      }
    }
  }

  .theme_standard_search_48 {
    .label_show {
      font-size: ${({ theme }) => theme.FONT.SIZE.S16};
      font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
      color: ${({ theme }) => theme.COLORS.GRAY_23};
      margin-bottom: 4px;
    }
    .line_search {
      display: flex;
      justify-content: space-between;
      .search_layout {
        width: 100%;
        position: relative;
        .icon {
          position: absolute;
          top: 13px;
          right: 16px;
          cursor: pointer;
        }
        .input_serach {
          font-size: ${({ theme }) => theme.FONT.SIZE.S16};
          font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
          color: ${({ fontColor, theme }) =>
            fontColor ? fontColor : theme.COLORS.GRAY_23};
          width: 100%;
          border: 1px solid ${({ theme }) => theme.COLORS.GRAY_10};
          padding: 12.4px 10px;
          padding-right: 48px;
          border-radius: 8px;
          box-sizing: border-box;
          &::-webkit-input-placeholder {
            /* Chrome/Opera/Safari */
            color: ${({ theme }) => theme.COLORS.GRAY_30};
          }
          &::-moz-placeholder {
            /* Firefox 19+ */
            color: ${({ theme }) => theme.COLORS.GRAY_30};
          }
          &:-ms-input-placeholder {
            /* IE 10+ */
            color: ${({ theme }) => theme.COLORS.GRAY_30};
          }
          &:-moz-placeholder {
            /* Firefox 18- */
            color: ${({ theme }) => theme.COLORS.GRAY_30};
          }
        }
      }
      .btn_serach {
        width: 25%;
      }
    }
    .show_label {
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      margin-top: 1px;
      display: flex;
      justify-content: flex-end;
      .btn_label {
        width: 25%;
        text-align: center;
      }
    }
  }
`;
